import { render, staticRenderFns } from "./AdminViewUserList.vue?vue&type=template&id=3b88c02e&scoped=true&"
import script from "./AdminViewUserList.vue?vue&type=script&lang=js&"
export * from "./AdminViewUserList.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewUserList.vue?vue&type=style&index=0&id=3b88c02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88c02e",
  null
  
)

export default component.exports